<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月22日 11:02:34 +0800
 * @最后修改时间: 2021-03-10 16:58:57
 * @FilePath: /mrc-ess-fronted/src/Page/Ess/Roster/RosterFormRecord/components/DateSelect.vue
 -->
<template>
  <v-container
    fluid
    class="
      fill-height
      max-width
      pa-0
      d-flex
      flex-row flex-grow-1
      justify-space-between
    "
  >
    <div class="max-width text-start pl-2">
      <!-- bug1459 mel -->
      <div :class="year.indexOf('-') != -1 ? 'text-caption' : 'text-caption'">
        {{ year }} {{ month }}
      </div>
      <div class="title font-weight-black text-truncate">
        <!-- <span class=" green--text material-icons-round md-18">
          brightness_1
        </span>-->
      </div>
    </div>
  </v-container>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "DateSelect",
  props: {
    startTime: { default: "", type: String },
    endTime: { default: "", type: String },
  },
  computed: {
    year() {
      if (this.startTime && this.endTime) {
        if (dayjs(this.startTime).year() == dayjs(this.endTime).year()) {
          return dayjs(this.startTime).year().toString();
        } else {
          return (
            dayjs(this.startTime).year() + " - " + dayjs(this.endTime).year()
          );
        }
      } else {
        return "";
      }
    },
    month() {
      if (this.startTime && this.endTime) {
        const startM = dayjs(this.startTime).month();
        const endM = dayjs(this.endTime).month();
        if (startM === endM) {
          return this.$t(this.getMonthKey(startM + 1));
        } else {
          return (
            this.$t(this.getMonthKey(startM + 1)) +
            " - " +
            this.$t(this.getMonthKey(endM + 1))
          );
        }
      } else {
        return "";
      }
    },
  },
  data() {
    return {};
  },
  methods: {
    getMonthKey: function (month) {
      switch (Number(month)) {
        case 1:
          return "label_essweb_system_JanuaryLabel";
          break;
        case 2:
          return "label_essweb_system_FebruaryLabel";
          break;
        case 3:
          return "label_essweb_system_MarchLabel";
          break;
        case 4:
          return "label_essweb_system_AprilLabel";
          break;
        case 5:
          return "label_essweb_system_MayLabel";
          break;
        case 6:
          return "label_essweb_system_JuneLabel";
          break;
        case 7:
          return "label_essweb_system_JulyLabel";
          break;
        case 8:
          return "label_essweb_system_AugustLabel";
          break;
        case 9:
          return "label_essweb_system_SeptemberLabel";
          break;
        case 10:
          return "label_essweb_system_OctoberLabel";
          break;
        case 11:
          return "label_essweb_system_NovemberLabel";
          break;
        case 12:
          return "label_essweb_system_DecemberLabel";
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped></style>
